var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86602 15.5C9.48112 16.1667 8.51888 16.1667 8.13397 15.5L0.339745 2C-0.0451559 1.33333 0.435969 0.500002 1.20577 0.500002L16.7942 0.5C17.564 0.5 18.0452 1.33333 17.6603 2L9.86602 15.5Z",
    fill: "#FC9D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon4);
export default __webpack_public_path__ + "static/media/Polygon4.c796d4f7.svg";
export { ForwardRef as ReactComponent };